import { render, staticRenderFns } from "./workCompanyName.vue?vue&type=template&id=2ca2da1d&scoped=true"
import script from "./workCompanyName.vue?vue&type=script&lang=js"
export * from "./workCompanyName.vue?vue&type=script&lang=js"
import style0 from "./workCompanyName.vue?vue&type=style&index=0&id=2ca2da1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2da1d",
  null
  
)

export default component.exports